export const cleanObject = (obj: any): any => {
    if (Array.isArray(obj)) {
        const hasNonNullValues = obj.some(item => Object.values(item).some(innerValue => innerValue && innerValue !== null));
        return hasNonNullValues ? obj : undefined;
    }

    if (typeof obj === 'object' && obj !== null) {
        const result: any = {};
        for (const key in obj) {
            const value = obj[key];
            const cleanedValue = cleanObject(value);
            if (cleanedValue !== undefined) {
                result[key] = cleanedValue;
            }
        }

        return result;
    }
    return obj;
};

export const convertDecimals = (obj: any): any => {
    if (Array.isArray(obj)) {
        return obj.map(element => convertDecimals(element));
    } else if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).reduce((acc: any, key) => {
            acc[key] = convertDecimals(obj[key]);
            return acc;
        }, {});
    } else {
        return typeof obj === 'number' ? Math.round(obj * 100) / 100 : obj;
    }
};
